/* global mixpanel */
export function settingCheckoutStart () {
  mixpanel.track('Setting Checkout Start')
}

export function settingCheckoutUpdate ({settings}) {
  mixpanel.track('Setting Checkout Update', {
    'Tax Enable': settings.enable_tax,
    'Gratuity Enable': settings.enable_gratuity,
    'Include or Add': settings.include_gratuity_tax,
    'Track Server': settings.track_server
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/settings/checkout.js